export default "__VITE_ASSET__Drj7aNzr__"